(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.createResponsiveFloorplanTabs = {
    attach: function (context, settings) {
      var options = {
        allowAllClosed: true, // allows tab panels to be closed in accordion mode
      };

      // pre init
      var presetFloorplan = $(".floorplan-tabs");

      // find first item and make it active/expanded
      presetFloorplan.each(function (index) {
        $(this).find(".accordion-item").first().addClass("is-active");
        var iteration = "accordion" + index;
        iteration = new Foundation.ResponsiveAccordionTabs($(this), options);
      });

      var minHeight = presetFloorplan.outerHeight(true);
      if (window.matchMedia("(min-width: 768px)").matches) {
        $(".tabs-panel").css("min-height", minHeight);
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
